module.exports = __webpack_public_path__ + "img/enterprise_success.411bfbb1.svg";